import * as Yup from 'yup';
import { IFormDefinition } from '../formDefinitionInterface';
import { ISignUpForm } from './types';

export class SignUpFormDefinition implements IFormDefinition {
  public validationSchema: any = Yup.object().shape({
    firstName: Yup.string().required('First name is required').max(40, 'First name is too long'),
    lastName: Yup.string().required('Last name is required').max(40, 'Last name is too long'),
    email: Yup.string().email('Must use a valid email').required('Email is required'),
    password: Yup.string().min(8, 'Password must be at least 8 characters'),
    passwordConfirmation: Yup.string()
      .oneOf([Yup.ref('password'), null], "Passwords don't match")
      .required('Confirm Password is required'),
  });

  public initialValues(): ISignUpForm {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      passwordConfirmation: '',
    };
  }

  public HUMANIZATION_MAP = {
    'contactInfo.email': 'Email',
    email: 'Email',
    customers: 'Customer',
    firstName: 'First name',
    lastName: 'Last name',
    password: 'Password',
    passwordConfirmation: 'Password confirmation',
  };
}
